var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wrap",staticClass:"wrap"},[_c('div',{ref:"content",staticClass:"content",class:_vm.animationClass,style:(_vm.contentStyle),on:{"animationend":_vm.onAnimationEnd,"webkitAnimationEnd":_vm.onAnimationEnd}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }